(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('MetadataRepository', [
        '$filter',
        '$q',
        'AprimaRestangular',
        'LocalStorageRepository',
        'moment',
        MetadataRepository
    ]);

    function MetadataRepository(
        $filter,
        $q,
        aprimaRestangular,
        LocalStorageRepository,
        moment
    ) {

        var service = {
            getMetadata: getMetadataFromStorageOrServer,
            parseRawMetadata: parseRawMetadata,
        };

        return service;

        function getKey(typeName) {
            return 'metadata.' + typeName;
        }

        function getMetadataFromServer(typeName) {
            return aprimaRestangular.get().one('metadata/' + typeName).get();
        }

        function getMetadataFromStorage(typeName) {
            var metadata = LocalStorageRepository.getKey(getKey(typeName), 'metadata'),
                deferred = $q.defer();

            if (metadata) {
                deferred.resolve(metadata);
            }
            else {
                deferred.reject('Metadata was not in storage');
            }

            return deferred.promise;
        }

        function getMetadataFromStorageOrServer(typeName, $scope) {
            return getMetadataFromStorage(typeName)
                .catch(function () {
                    return getMetadataFromServer(typeName).then(function (metadata){
                        return parseRawMetadata(metadata);
                    });
                })
                .then(function (metadata) {
                    LocalStorageRepository.setKey(getKey(typeName), metadata, 'metadata');
                    return metadata;
                })
                .then(function(metadata){
                    if($scope){
                        $scope.metadata = metadata;
                    }

                    return metadata;
                });
        }

        function parseRawMetadata(rawMetadata) {
            rawMetadata.Fields = metadataParser(rawMetadata);
            return rawMetadata;
        }

        function metadataParser(metadata) {
            var fields = {};

            _.forEach(metadata.Fields, function (field) {
                var dots = field.FieldName.split('.'),
                    obj = fields,
                    propertyName;

                while (dots.length > 1) {
                    propertyName = dots.shift();
                    if (!fields[propertyName]) {
                        fields[propertyName] = {};
                    }

                    obj = fields[propertyName];
                }

                propertyName = dots.shift();
                obj[propertyName] = field;

                if(field.ElementMetadata) {
                    field.Fields = metadataParser(field.ElementMetadata);
                    delete field.ElementMetadata;
                }

                if(field.FieldName.indexOf('Date') >= 0 || field.FieldName.indexOf('date') >= 0){
                    if(field.Minimum){
                        // field.Minimum for dates should be iso8601 date string, which moment can handle
                        field.Minimum = moment(field.Minimum).toDate();
                    }

                    if(field.Maximum){
                        // field.Maximum for dates should be iso8601 date string, which moment can handle
                        field.Maximum = moment(field.Maximum).toDate();
                    }
                }
            });

            return fields;
        }
    }

})(window.angular);
